import React from 'react';

const CandidateHeaderActionDropdown = (props) => {
    const {
        candidateId,
        onClickFindJob,
        onClickEmailInviteDVTJCUV,
        onClickEmailInviteSendJob,
    } = props;

    const summaryHref = `/dvtjcuv/receiver-summary?cddId=${candidateId || ''}&&recId=`;

    return (
        <div className="btn-group">
            <button type="button" className="btn btn-default">Action</button>
            <button type="button"
                    className="btn btn-default dropdown-toggle dropdown-icon"
                    data-toggle="dropdown">
                <span className="sr-only">Toggle Dropdown</span>
            </button>
            <div className="dropdown-menu" role="menu">
                <button type="button"
                        className="dropdown-item"
                        onClick={onClickFindJob}>
                    Tìm Job
                </button>
                <a href={summaryHref}
                   target="_blank"
                   rel="noopener noreferrer"
                   className="dropdown-item">
                    Tổng hợp theo Cdd
                </a>
                <button type="button"
                        className="dropdown-item"
                        onClick={onClickEmailInviteDVTJCUV}>
                    Email mời DVTJCUV
                </button>
                <button type="button"
                        className="dropdown-item"
                        onClick={onClickEmailInviteSendJob}>
                    Gửi Email MỜI GỬI JOB
                </button>
            </div>
        </div>
    );
};

export default CandidateHeaderActionDropdown;
